import { ChangeDetectorRef, Directive, EmbeddedViewRef, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AsyncState } from '@cawita/core-front/state';
import { SubSink } from 'subsink';
import { NotificationState, NotificationStore } from './notification.store';

export interface NotificationCountContext {
    $implicit: number;
}

@Directive({ selector: '[cwtNotificationCount]' })
export class NotificationCountDirective implements OnInit {
    private sub = new SubSink();
    private ctx: NotificationCountContext = { $implicit: null };
    private _view: EmbeddedViewRef<NotificationCountContext>;

    constructor(
        protected store: NotificationStore,
        protected tRef: TemplateRef<NotificationCountContext>,
        protected vcRef: ViewContainerRef,
        protected cdRef: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.sub.sink = this.store.state$.subscribe((state) => this._onStateChange(state));
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    private _onStateChange(state: NotificationState & AsyncState) {
        if (state.initialized && !!state.count) {
            this.ctx.$implicit = state.count;
            if (!this._view) this._view = this.vcRef.createEmbeddedView(this.tRef, this.ctx);
            this._view.markForCheck();
        } else {
            this.vcRef.clear();
            this._view = null;
        }
    }
}